import { type AxiosProgressEvent } from 'axios';
import { FileUploaded, ServiceResult, UploadSource } from '@borg/types';

class FileUploadService {
  async upload(
    file: File & { clientId?: string },
    source: UploadSource,
    uploadProgress?: (progress: number) => void,
  ): ServiceResult<FileUploaded> {
    function onUploadProgress(event: AxiosProgressEvent) {
      const progress = event.total ? (event.loaded / event.total) * 100 : 1;
      uploadProgress && uploadProgress(progress);
    }

    const formData = new FormData();
    formData.append('file', file);

    const result = await serviceHttpPostFactory<FileUploaded>(
      `/uploads?source=${source}`,
      formData,
      {
        onUploadProgress,
      },
    );

    if (result.isSuccess) {
      result.data.clientId = file.clientId;
      return result;
    }

    return result;
  }
}

export const fileUploadService = new FileUploadService();
